import { Component, OnInit } from '@angular/core';
import { GridApi } from 'ag-grid-community';
import { Router, ActivatedRoute } from '@angular/router';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { UmSummaryService } from 'src/app/services/um/um-summary.service';
import { ConfigurePolicyModalComponent } from './configure-policy-modal/configure-policy-modal.component';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Module } from '../../models/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from 'src/app/services/common.service';
import { VersionHistoryComponent } from './version-history/version-history.component';
import { VersionDetailsComponent } from './version-details/version-details.component';

@Component({
  selector: 'app-policy-configurator',
  templateUrl: './policy-configurator.component.html',
  styleUrls: ['./policy-configurator.component.scss']
})
export class PolicyConfiguratorComponent implements OnInit {


  gridApi: GridApi;
  collapesedOrNot: boolean = false;
  columnDefs;
  operations;
  rowData;
  selectedRow;
  DocumentSearch: UntypedFormGroup;
  modulecode: any = '';
  screencode: any = '';
  PermissionID: any = '';
  modulelist: Module[] = [];
  tempoperation: any[];

  constructor(
    private router: Router,
    public route: ActivatedRoute,
    private summaryService: UmSummaryService,
    private modalService: NgbModal,
    private commonService: CommonService
  ) {
    this.modulecode = route.snapshot.params['code'];
  }

  ngOnInit() {
    switch (this.modulecode) {
      case "ist":
        this.screencode= "PC-001"
        this.PermissionID="207";
        break;
      case "eap":
        this.screencode= "PC-002"
        this.PermissionID="506";
        break;
      case "grantscme":
        this.PermissionID="408";
        this.screencode="PC-003";
        break;
      case "grantscharitable":
        this.PermissionID="406";
        this.screencode= "PC-005"
        break;
      case "grantssponsorship":
        this.screencode= "PC-004";
         this.PermissionID="407";
        break;
    }
    this.columnDefs = [
      {
        "headerName": "Name",
        "field": "NAME"
      },
      {
        "headerName": "Status",
        "field": "StatusExt",
      },
      {
        "headerName":"Version #",
        "field": "LAST_VERSION_NO",
      }
    ];
    this.DocumentSearch = new UntypedFormGroup({
      NAME: new UntypedFormControl(),
      StatusExt: new UntypedFormControl("-1"),
      MODULE: new UntypedFormControl(this.screencode),
    });

    this.tempoperation = [];
    if (this.commonService.getScreenPermission(this.PermissionID, "E")) {
      this.tempoperation.push({
        "name": "Edit",
        "id": "edit"
      });
    }
    if (this.commonService.getScreenPermission(this.PermissionID, "D")) {
      this.tempoperation.push({
        "name": "Delete",
        "id": "delete"
      });
    }
    if (this.commonService.getScreenPermission(this.PermissionID, "V")) {
      this.tempoperation.push({
        "name": "View",
        "id": "view"
      });
    }
    if (this.commonService.getScreenPermission(this.PermissionID, "N")) {
      this.tempoperation.push({
        "name": "Add Workflow",
        "id": "add"
      });
    }
    this.tempoperation.push({
      "name": "Version History",
      "id": "versionHistory"
    });
    this.operations = this.tempoperation.map(operation => {
      return (operation && (operation.id === 'add' || operation.id === 'view_modal')) ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    });
    this.setSummary();
  }

 

  setSummary() {
    this.summaryService.getPolicyConfig(this.DocumentSearch.getRawValue()).subscribe(summary => {
      this.rowData = summary;
    });

  }

  ViewAll() {
    this.DocumentSearch = new UntypedFormGroup({
      NAME: new UntypedFormControl(),
      StatusExt: new UntypedFormControl("-1"),
      MODULE: new UntypedFormControl(this.screencode),
    });
    this.setSummary();
  }

  SearchClear() {
    this.DocumentSearch = new UntypedFormGroup({
      NAME: new UntypedFormControl(),
      StatusExt: new UntypedFormControl("-1"),
      MODULE: new UntypedFormControl(this.screencode),
    });
  }

  AdvanceSearch() {
    this.setSummary();
  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  onRowDoubleClicked(event) {
   
  }

  edit() {
    const modelRef = this['self'].modalService.open(ConfigurePolicyModalComponent, {
      keyboard: false,
      backdrop: false,
      windowClass: 'modal-xxl right modal-right',
      animation: true,
    });
    modelRef.componentInstance.Content = {
      heading: 'Edit',
      Policy_ID:this['self'].selectedRow['ID'],
      screencode:this['self'].screencode
    }
    modelRef.result.then(res => {
      this['self'].setSummary();
     });
  }

  add() {
   
    const modelRef = this['self'].modalService.open(ConfigurePolicyModalComponent, {
      keyboard: false,
      backdrop: false,
      windowClass: 'modal-xxl right modal-right',
      animation: true,
    });
    modelRef.componentInstance.Content = {
      heading: 'New',
      policyid: "",
      screencode:this['self'].screencode
    }
    modelRef.result.then(res => {
      this['self'].setSummary();
     });
  }
  delete() {
    const modalRef = this['self'].modalService.open(DeleteBoxComponent,{backdrop: false})
    modalRef.componentInstance.Content={heading: 'Delete', custommessage: 'Are you sure you want to delete the workflow?',ProceedButtonName:"Delete", TerminateButtonName:"Cancel"}
    modalRef.result.then(result => {
    if(result=="okclick")
    {
      this['self'].ProccedDelete(this['self'].selectedRow['ID'])
    }
   }); 
  }
   ProccedDelete(id:any){
    this.summaryService.deletePolicy(id).subscribe((result) => {
      if (result.Status === 0) {
        this.commonService.SuccessBanner("Workflow '"+this.selectedRow['NAME']+"' deleted successfully");
        this.setSummary();
      }
      else {
        this.commonService.ValidationBanner("You cannot delete this workflow setup as it is being used in configurations/applications");
      }
    });
   }


  view()
  {
   
      let modalRef = this['self'].modalService.open(VersionDetailsComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-vlg right modal-right',
        animation: true
      });
      modalRef.componentInstance.Content = {
        VersionID:"view",
        screencode:this['self'].screencode,
        Policy_ID:this['self'].selectedRow['ID'],
        Heading:"View Workflow Setup"
      }
      modalRef.result.then(result => {
  
      });
    
  }
  versionHistory() {
    let modalRef = this['self'].modalService.open(VersionHistoryComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content={
      screencode:this['self'].screencode,
      Policy_ID:this['self'].selectedRow['ID']
    }
    modalRef.result.then(res => {
     // this.getStates();
    });
  }
  configurepolicy() {
    const modelRef = this['self'].modalService.open(ConfigurePolicyModalComponent, {
      backdrop: false,
      keyboard: false,
      // ignoreBackdropClick: true,
      windowClass: 'modal-llg right modal-right',
      animation: true,
    });
    modelRef.componentInstance.Content = {
      heading: '',
      content: null,
      policyid: this['self'].selectedRow['ID']
    }
  }
}
